import { User } from "../user";
import { Call } from "../../../../api/apiCall";
import { LogItem } from "../../../../api/logItem";

export const insertNewUser = async (
  cUser: User,
  logItem: LogItem,
): Promise<Response> => {
  try {
    const res = await Call("users/new", "post", { user: cUser }, logItem);

    if (res.ok) {
      return new Response(JSON.stringify(await res.json()), {
        status: res.status,
        headers: { "Content-Type": "application/json" },
      });
    } else {
      const errorData = await res.json();
      console.error("Errore API lato server:", errorData);
      return new Response(JSON.stringify(errorData), {
        status: res.status,
        headers: { "Content-Type": "application/json" },
      });
    }
  } catch (error) {
    console.error("Errore di rete:", error);
    return new Response(
      JSON.stringify({
        success: false,
        message: "Errore di rete o server non raggiungibile",
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      },
    );
  }
};
